/**
 * Utility helper to safely extract human-readable error messages from Axios or Fetch errors.
 */

export function getErrorMessage(error, defaultMessage = "An unexpected error occurred. Please try again.") {
  if (!error) return defaultMessage;

  // Axios response error object
  if (error.response?.data) {
    const data = error.response.data;
    if (typeof data === "string" && data.trim()) return data;
    if (data.error && typeof data.error === "string") return data.error;
    if (data.message && typeof data.message === "string") return data.message;
  }

  // Standard JS Error message
  if (error.message && typeof error.message === "string" && !error.message.includes("Network Error")) {
    return error.message;
  }

  if (error.message && error.message.includes("Network Error")) {
    return "Network error: Unable to connect to server. Please check your connection.";
  }

  return defaultMessage;
}
